// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as AuthContextV1$PorterinFeature from "../../../login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as OrderHistoryStore$PorterinFeature from "../../domian/store/OrderHistoryStore.mjs";
import * as OrderReviewHelper$PorterinFeature from "../../../order-review/domain/helpers/OrderReviewHelper.mjs";
import * as OrderHistoryHelper$PorterinFeature from "../../domian/helpers/OrderHistoryHelper.mjs";
import * as LiveOrderCardModuleScss from "../styles/LiveOrderCard.module.scss";
import * as LiveOrderCardFallBackCmp$PorterinFeature from "./LiveOrderCardFallBackCmp.mjs";

var styles = LiveOrderCardModuleScss;

function LiveOrderCardCmp(Props) {
  var has_rounded_cornersOpt = Props.has_rounded_corners;
  var has_rounded_corners = has_rounded_cornersOpt !== undefined ? has_rounded_cornersOpt : false;
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var order_history = match.order_history;
  if (typeof order_history === "number") {
    return React.createElement(LiveOrderCardFallBackCmp$PorterinFeature.make, {});
  }
  switch (order_history.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(LiveOrderCardFallBackCmp$PorterinFeature.make, {});
    case /* Live */1 :
        var match$1 = order_history._0.length;
        if (match$1 !== 0) {
          return React.createElement("div", {
                      className: has_rounded_corners ? "" + styles["rounded-corners"] + " " + styles["live-order-card-container"] + "" : styles["live-order-card-container"]
                    }, React.createElement("div", {
                          className: styles["live-order"]
                        }, React.createElement("div", {
                              className: styles.live
                            }, OrderHistoryStore$PorterinFeature.live_order_card_status), React.createElement("div", {
                              className: styles.text
                            }, OrderHistoryStore$PorterinFeature.live_order_card_text)), React.createElement("button", {
                          className: styles["view-status"],
                          onClick: (function (param) {
                              var match = OrderHistoryHelper$PorterinFeature.countOfLiveOrder(order_history) > 1;
                              var match$1 = OrderHistoryHelper$PorterinFeature.isCourierOrder(order_history, 0);
                              if (match) {
                                return JsBindings$PorterinUtils.redirect(Config$PorterinUtils.oms_url + "/order-history");
                              } else if (match$1) {
                                return OrderReviewHelper$PorterinFeature.courierTrackingLinkRedirect(OrderHistoryHelper$PorterinFeature.orderCrn(order_history, 0));
                              } else {
                                return OrderReviewHelper$PorterinFeature.allocationLinkRedirect(OrderHistoryHelper$PorterinFeature.orderCrn(order_history, 0));
                              }
                            })
                        }, OrderHistoryStore$PorterinFeature.live_order_button));
        } else {
          return null;
        }
    case /* Error */2 :
        return null;
    
  }
}

var make = LiveOrderCardCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
